var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6652 15.3065C26.1583 15.9462 24.9177 16.4013 24.9177 16.4013L15.6927 19.715V17.271L22.4819 14.853C23.2528 14.5777 23.371 14.1858 22.7443 13.9817C22.1191 13.776 20.9871 13.8359 20.2178 14.1113L15.6927 15.7049V13.1687L15.9534 13.0812C15.9534 13.0812 17.2604 12.618 19.0986 12.414C20.9368 12.2115 23.188 12.4415 24.955 13.1104C26.947 13.742 27.1705 14.6684 26.6652 15.3065ZM16.5705 11.1475V4.89594C16.5705 4.16228 16.4361 3.48692 15.7478 3.29581C15.2198 3.12576 14.8926 3.61649 14.8926 4.34853V20L10.672 18.6606V0C12.4665 0.33363 15.0805 1.12074 16.4863 1.59527C20.0607 2.82128 21.2721 4.34853 21.2721 7.7901C21.2721 11.1442 19.2023 12.4156 16.5705 11.1458V11.1475ZM2.92729 17.0184C0.8834 16.4386 0.543292 15.2401 1.47454 14.5502C2.33615 13.9121 3.80024 13.4327 3.80024 13.4327L9.85255 11.2786V13.7323L5.49592 15.2919C4.72825 15.5673 4.61002 15.9576 5.23517 16.1632C5.86032 16.3673 6.9924 16.309 7.76169 16.0337L9.85093 15.2741V17.4702L9.4347 17.5399C7.25511 17.8928 5.02252 17.7133 2.92729 17.0168V17.0184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystationIcon);
export default __webpack_public_path__ + "static/media/playstation-icon.211e430e08e825dd72ed4f1eb8974ead.svg";
export { ForwardRef as ReactComponent };